export function numberToWords(number, language = "lv") {
  const languages = {
    lv: {
      units: ["", "viens", "divi", "trīs", "četri", "pieci", "seši", "septiņi", "astoņi", "deviņi"],
      teens: [
        "desmit",
        "vienpadsmit",
        "divpadsmit",
        "trīspadsmit",
        "četrpadsmit",
        "piecpadsmit",
        "sešpadsmit",
        "septiņpadsmit",
        "astoņpadsmit",
        "deviņpadsmit",
      ],
      tens: [
        "",
        "desmit",
        "divdesmit",
        "trīsdesmit",
        "četrdesmit",
        "piecdesmit",
        "sešdesmit",
        "septiņdesmit",
        "astoņdesmit",
        "deviņdesmit",
      ],
      hundreds: [
        "",
        "simts",
        "divi simti",
        "trīs simti",
        "četri simti",
        "pieci simti",
        "seši simti",
        "septiņi simti",
        "astoņi simti",
        "deviņi simti",
      ],
      thousands: "tūkstoši",
      euro: "euro",
      and: "un",
      cents: "centi",
    },
    en: {
      units: ["", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine"],
      teens: [
        "ten",
        "eleven",
        "twelve",
        "thirteen",
        "fourteen",
        "fifteen",
        "sixteen",
        "seventeen",
        "eighteen",
        "nineteen",
      ],
      tens: [
        "",
        "ten",
        "twenty",
        "thirty",
        "forty",
        "fifty",
        "sixty",
        "seventy",
        "eighty",
        "ninety",
      ],
      hundreds: [
        "",
        "one hundred",
        "two hundred",
        "three hundred",
        "four hundred",
        "five hundred",
        "six hundred",
        "seven hundred",
        "eight hundred",
        "nine hundred",
      ],
      thousands: "thousand",
      euro: "euros",
      and: "and",
      cents: "cents",
    },
  }

  const { units, teens, tens, hundreds, thousands, euro, and, cents } = languages[language]

  function convertUnderThousand(n, lang) {
    if (n < 10) return units[n]
    if (n >= 10 && n < 20) return teens[n - 10]
    if (n >= 20 && n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? " " + units[n % 10] : "")
    if (n >= 100) {
      const remainder = n % 100
      const hundredPart = hundreds[Math.floor(n / 100)]
      const remainderPart = remainder ? " " + convertUnderThousand(remainder, lang) : ""
      return hundredPart + remainderPart
    }
  }

  function convertNumberToWords(n) {
    if (n === 0) return language === "lv" ? "nulle" : "zero"
    let parts = []

    if (n >= 1000) {
      parts.push(convertUnderThousand(Math.floor(n / 1000), language) + " " + thousands)
      n %= 1000
    }

    if (n > 0) {
      parts.push(convertUnderThousand(n, language))
    }

    return parts.join(" ").trim()
  }

  let [integerPart, decimalPart] = number.toString().split(".")
  let words = convertNumberToWords(parseInt(integerPart, 10))

  words += " " + euro
  if (decimalPart) {
    if (decimalPart.length === 1) {
      decimalPart += "0"
    }
    words += " " + and + " " + decimalPart + " " + cents
  }

  return words.charAt(0).toUpperCase() + words.slice(1)
}
